import { render, staticRenderFns } from "./alliances.vue?vue&type=template&id=c0848ac8&scoped=true&"
import script from "./alliances.vue?vue&type=script&lang=js&"
export * from "./alliances.vue?vue&type=script&lang=js&"
import style0 from "./alliances.vue?vue&type=style&index=0&id=c0848ac8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0848ac8",
  null
  
)

export default component.exports